import Backbone from 'backbone'
import leftClick from './left-click'
import _ from 'lodash'
import connectors from './support/connectors/group'
import Paintable from './support/paintable'

var WobView = Backbone.View.extend({

  className: 'wob',

  attributes: function () {
    // Slap a data-id attribute on the wob view that matches the wob model cid
    return {
      'data-id': this.model.cid
    }
  },

  events: {
    'mousedown': 'toggleSelect',
    'touchstart': 'beginTouch'
  },

  /*
   * Builds the view for the wob.
   */
  initialize: function (options) {
    // readonly might be set by the canvas and passed in as a constructor option
    this.readonly = typeof options.readonly === 'undefined' ? false : options.readonly

    // individual wobs may also be readonly even when the canvas isn't
    if (this.model.get('readonly') === true) {
      this.readonly = true
    }

    this.canvas = options.canvas

    // Read only wobs cannot be selected
    if (!this.readonly) {
      // When the wob is selected...
      this.listenTo(this.model, 'change:selected', function (wob, bool) {
        this.$el.toggleClass('selected', bool)
        this.$el.trigger('selected', bool) // Fired on the wob view/container
      }, this)
    }

    // TODO Do we want to prevent this for readonly wobs?
    this.listenTo(this.model, 'change:connectorHead', function (wob, bool) {
      this.$el.toggleClass('connector-attach-to', bool)
    })

    if (this.model.isNew()) {
      // Use defaults, but only for props that aren't already specified
      var specified = _(this.model.toJSON()).toPairs()
                                            .filter(function (pair) {
                                              return !(pair[1] === null || pair[1] === undefined)
                                            })
                                            .map(function (pair) {
                                              return pair[0]
                                            })
                                            .value()
        , props = _.omit(this.defaults(), specified)

      for (var k in props) {
        this.set(k, props[k])
      }
    }

    this.paint()

    this.listenTo(this.model, 'move', function () {
      this.$el.trigger('moved', this.props())
    })

    this.listenTo(this.model, 'resize', function (model, previous) {
      this.$el.trigger('resized', _.extend({previous: previous}, this.props()))
    })

    this.listenTo(this.model, 'change', (model, opts) => this.paint(opts.animate))
    this.listenTo(this.model, 'destroy remove', function () {
      this.release()
    })

    // If something within a connector changed through an API call (e.g. `connector.set('style', {})`),
    // or a connector is added/removed from the wob, then we need to update the wob's connectors
    this.listenTo(this.model, 'change:connectors', this.updateConnectors)

    this.listenTo(this.model, 'resize move change:rotate', function (wob) {
      this.updateConnectors()
      // Check if any wobs that have connectors are attached to this wob
      this.canvas.collection.forEach(function (_wob) {
        if (_wob === wob) { return }
        var connected = _wob.get('connectors')
                            .filter(function (connector) {
                              if (!(connector instanceof Backbone.Model)) {
                                // This was triggered by a history pop and the
                                // connector hasn't been converted a real model. Ignore for now
                                return false
                              }
                              return connector.get('to') && connector.get('to').cid == wob.cid
                            })

        if (connected.length) {
          // _wob has a connector attached to the `wob`... It needs to be updated
          _wob.get('connectors').trigger('change')
        }
      })
    })

    this.listenTo(this.model, 'predestroy', function (wob) {
      // Might have to remove connectors if it has them
      this.updateConnectors()
      // There is a chance that the connectors are an array instead of a
      // collection from popping the history. This will check for and take care
      // of that
      this.canvas.collection.set()
      // If any other wob has connecters attached to this wob, remove those connectors
      this.canvas.collection.forEach(function (_wob) {
        if (_wob === wob) { return }
        var connected = _wob.get('connectors')
                            .filter(function (connector) {
                              return connector.get('to') && connector.get('to').cid == wob.cid
                            })
        _wob.get('connectors').remove(connected)
      })
    })
  },

  /*
   * Updates all connectors on this wob
   */
  updateConnectors: function () {
    if (!(this.model.get('connectors') instanceof Backbone.Collection)) {
      // This is a bit of a hack, but if this is fired from a call to `wobs.set`, the connectors may
      // still be an array. We can't handle an array of connectors, they must be a collection. It will
      // fix itself once we set the connectors to a true collection
      return
    }
    this.canvas.connectorsContainer.call(connectors, this.canvas, this.cid, this.model.get('connectors'))
  },

  beginTouch: function (e) {
    var self = this
      , moving = null

    if (!this.model.selected) {
      // If wob isn't selected and user starts a touch, wait to see if they move
      this.$el.one('touchmove', function (e) {
        moving = true
      })

      // On tap, iOS goes touchstart > touchmove (optional) > touchend > click
      // The configurer appears after toggleSelect, so if we toggleSelect on touchend,
      // the subsequent click event may trigger the configurer. See issue dash #439
      this.$el.one('click', function (e) {

        // If they didn't do a touchmove, then select it
        if (!moving) {
          self.toggleSelect(e)
        }
      })
    }
  },

  disableEvents: function () {
    this.$el.addClass('disable-events')
  },

  enableEvents: function () {
    this.$el.removeClass('disable-events')
  },

  defaults: function () {
    var defaults = {
      width: 200,
      height: 200
    }

    var widgetDefaults = this.model.widget.containerDefaults
    // Apply widget container defaults to the wob
    _.keys(widgetDefaults).forEach(function (key) {
      defaults[key] = widgetDefaults[key]
    })

    return defaults
  },

  get: function (key) {
    return this.model.get(key)
  },

  set: function (key, value) {
    if (typeof key === 'object') {
      for (var k in key) {
        var v = key[k]
        this.model.set(k, v)
      }
    } else {
      this.model.set(key, value)
    }
    this.paint()
  },

  toggleSelect: _.wrap(function (e) {
    if (this.model.selected) {
      this.$el.trigger('deselect:element', [this, e != null ? (e.shiftKey || e.metaKey || e.ctrlKey) : void 0])
    } else {
      this.$el.trigger('select:element', [this, e != null ? (e.shiftKey || e.metaKey || e.ctrlKey) : void 0])
    }
  }, _.partialRight(leftClick, true)),

  /*
   * This is the default algorithm for determing to draw line segments around the wob's widget.
   * By default it draws lines around the first child of its inner SVG.
   *
   * Specific widget types can override this to be more specific
   */
  lineSegments: function () {
    // TODO the more i play w/ this, the more i think this is super weird.... we are in wob view but this is invoked on a widget view. not good
    var container = this.connectorContainer && this.connectorContainer() || this.el.querySelectory('svg path:first-child')
      , pathLength = container.getTotalLength()
      , segments = 100

    return Array.apply(null, {length: segments}).map(function (d, i) {
      var pt1 = container.getPointAtLength(pathLength * i / segments)
        , pt2 = container.getPointAtLength(pathLength * (i + 1) / segments)

      return {
        x1: pt1.x + this.model.wob.get('left'),
        x2: pt2.x + this.model.wob.get('left'),
        y1: pt1.y + this.model.wob.get('top'),
        y2: pt2.y + this.model.wob.get('top')
      }
    }.bind(this))
  },

  render: function () {
    var widget = this.model.widget

    // this.view references the widget this wob is holding
    this.view = new widget.viewCls({model: widget, readonly: this.readonly, container: this.$el, canvas: this.canvas})
    this.view.lineSegments = this.view.lineSegments || this.lineSegments.bind(this.view)

    // When the view says it's ready, we also publish an event saying the wob is ready
    this.listenTo(this.view, 'ready', function () {
      this.trigger('ready', this) // Pass the wob, not the widget. The widget can be accessed by wob.view
    }, this)

    // Some widgets lock their aspect ratio. Let's set that on the wob ourself,
    // so the resizer doesn't need to know about a widget
    this.model.lockedAR = this.view.lockedAR
    // Same thing w/ the resizable
    this.model.resizable = this.view.resizable

    this.$el.append(this.view.el)
    this.view.render()

    if (this.readonly) {
      this.$el.addClass('read-only')
    }

    if (this.selectable) {
      this.$el.addClass('selectable')
    }
    return this
  },

  setSelected: function (bool) {
    this.model.setSelected(bool)
  },

  area: function () {
    return this.model.area()
  },

  /*
   * Sets the elements rotation
   */
  rotate: function (wob, angle) {
    this.$el.css('transform', angle ? 'rotate(' + angle + 'deg)' : '')
  },

  props: function () {
    var props = _.pick(this.model.attributes, 'width', 'height', 'left', 'top', 'rotate')
    props['z-index'] = this.model.getZindex()
    return props
  },

  resize: function (area) {
    this.set(area)
  },

  release: function () {
    this.view.release ? this.view.release() : this.view.remove()
    this.controlView && this.controlView.release()
    this.view = null
    this.remove()
  }
})

_.extend(WobView.prototype, Paintable)

export default WobView
